/**
 * Theme toggle component
 * Switch between light and dark mode
 */

import { Switch, Tooltip } from 'antd';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';

interface ThemeToggleProps {
  isDark: boolean;
  onToggle: () => void;
  showLabel?: boolean;
  size?: 'small' | 'default';
}

export function ThemeToggle({
  isDark,
  onToggle,
  showLabel = false,
  size = 'default',
}: ThemeToggleProps) {
  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        {showLabel && (
          <span style={{ color: 'var(--color-text-secondary)', fontSize: 14 }}>
            {isDark ? 'Dark' : 'Light'}
          </span>
        )}
        <Switch
          checked={isDark}
          onChange={onToggle}
          checkedChildren={<MoonOutlined />}
          unCheckedChildren={<SunOutlined />}
          size={size}
          aria-label="Toggle theme"
        />
      </div>
    </Tooltip>
  );
}

export default ThemeToggle;
